import { h, Host } from '@stencil/core';
import cn from 'classnames';
import { parseCommonURLToRouterParts } from '@pes-ui/utils';
import { isAppRoutingEnabled, navigateWithRouter } from '../../pes-router/utils';
import PesRoute from '../../pes-router/pes-route';
export class ProductCardIdSoftware {
  constructor() {
    this.onClickHandler = (event) => {
      var _a;
      (_a = this.onRecentlyViewedItemClick) === null || _a === void 0 ? void 0 : _a.call(this, {
        event,
        id: this.name,
        name: this.name,
        url: this.productUrl,
      });
      if (!isAppRoutingEnabled())
        return;
      navigateWithRouter(this.route, event.currentTarget);
    };
    this.name = undefined;
    this.productUrl = undefined;
    this.description = undefined;
    this.imageUrl = undefined;
    this.imageTitle = undefined;
    this.version = undefined;
    this.versionLabel = undefined;
    this.noMobileView = false;
    this.onRecentlyViewedItemClick = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (!isAppRoutingEnabled())
      return;
    const { pageType, pageId } = parseCommonURLToRouterParts(this.productUrl);
    this.route = new PesRoute({ page: pageType, pageId });
    this.productUrl = this.route.url;
  }
  render() {
    return (h(Host, { class: cn({ 'mode--desktop-only': this.noMobileView }) }, h("a", { href: this.productUrl, class: "card", onClick: this.onClickHandler }, h("pes-lazy-img", { class: "card__img", src: this.imageUrl, alt: this.imageTitle }), h("div", { class: "card__info" }, h("span", { class: "card__name" }, this.name), h("p", { class: "card__description" }, this.description ? h("pes-ellipsis", { maxHeight: "50px", content: this.description }) : ''), this.version && (h("p", { class: "card__version" }, this.versionLabel, " ", this.version))))));
  }
  static get is() { return "pes-product-card-id-software"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-card-id-software.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-card-id-software.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product commercial reference"
        },
        "attribute": "name",
        "reflect": false
      },
      "productUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Url of product description page"
        },
        "attribute": "product-url",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Product description"
        },
        "attribute": "description",
        "reflect": false
      },
      "imageUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Image url of a product"
        },
        "attribute": "image-url",
        "reflect": false
      },
      "imageTitle": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Image title of a product"
        },
        "attribute": "image-title",
        "reflect": false
      },
      "version": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Version number"
        },
        "attribute": "version",
        "reflect": false
      },
      "versionLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Version label"
        },
        "attribute": "version-label",
        "reflect": false
      },
      "noMobileView": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Only display card in \"Desktop mode\""
        },
        "attribute": "no-mobile-view",
        "reflect": false,
        "defaultValue": "false"
      },
      "onRecentlyViewedItemClick": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "(params: OnRecentlyViewedItemClickParams) => void",
          "resolved": "(params: OnRecentlyViewedItemClickParams) => void",
          "references": {
            "OnRecentlyViewedItemClickParams": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
